import Vue from 'vue'

import IOTDevice from './IOTDevice.js'

import store from '../../store'
import moment from 'moment'

// eslint-disable-next-line
import CloudWatchDeviceMetrics from '../../components/common/metrics/CloudWatchDeviceMetrics.js'
// eslint-disable-next-line
import NewDeviceMetrics from '../../components/common/metrics/NewDeviceMetrics.js'


export default class VideonEncoder extends IOTDevice {
  constructor(device_guid, device_attributes = false) {
    super(device_guid, device_attributes)
    
    this.device_type = 'encoder'
    
    // state tracking
    this.updatesAvailable = { 'daemon': false, 'system': false, 'cloud': false }
    
    this.deviceMetrics = false
    this.deviceMetricsCacheInterval = 3600 // updated via entitlements
    this.lastDeviceMetricsRequestAt = false
    this.fetchingMetrics = false
    
    this.inputPreviewDuration = 30
    this.inputPreviewInterval = 1
    this.lastInputPreviewRequestAt = false
    
    this.streaming_status = 5
    
    this.firmware_version = 'Unknown'
    this.system_version = false
    this.daemon_version = false
    this.cloud_version = false
    
    
    // device specific things
    this.shadowDocuments = ['Inputs', 'Encoders', 'Outputs', 'System', 'Alerts', 'Containers']
    
    
    // data fetching
    if (!this.state) {
      setTimeout(() => {
        this.fetchState()
      }, 1)
    }
    
    setTimeout(() => {
      this.fetchLicenses()
    }, Vue.helpers.getRefreshInterval(1, 10))
    
    setTimeout(() => {
      this.syncDocuments()
    }, Vue.helpers.getRefreshInterval(50, 100))
    
    setTimeout(() => {
      this.fetchMetadata()
    }, Vue.helpers.getRefreshInterval(50, 100))
    
    setTimeout(() => {
      this.checkForUpdates()
    }, 2000)
  }
  
  afterStateUpdate() {
    this.updateStreamingStatus()
  }
  
  refresh() {
    this.fetchDevice()
    this.fetchMetadata()
    this.syncDocuments()
    this.fetchUsers()
    this.fetchLicenses()
  }
  
  refreshProperties() {
    this.deviceName(true)
    this.deviceIP(true)
    this.IPScheme(true)
    this.updateStreamingStatus()
    this.firmwareVersion()
  }
  
  // accessibility methods
  icon() {
    if (this.product_name == 'edgecaster') {
      return '$edgecaster'
    } else if (this.product_name == 'edgecaster_max') {
        return '$edgecaster_max'
    }
    return '$videon_logo'
  }
  
  deviceName(refresh = false) {
    if (this.device_name && !refresh) {
      return this.device_name
    }
    
    if (this.metadata && this.hasMetadataKey('device_alias')) {
      this.device_name = Vue.helpers.htmlDecode(this.metadataValue('device_alias'))
      return this.device_name
    }
    
    var systemState = this.systemState()
    if (systemState && systemState.config && systemState.config.device_name) {
      this.device_name = Vue.helpers.htmlDecode(systemState.config.device_name)
      return this.device_name
    }
    
    this.device_name = this.serial_number + ' [' + this.mac_address + ']'
    return this.device_name
  }
  
  deviceIP(refresh = false) {
    if (this.device_ip && !refresh) {
      return this.device_ip
    }
    
    if (this.state) {
      if (this.state.device_ip) {
        this.device_ip = this.state.device_ip
      }
      if (this.state.external_ip) {
        this.external_ip = this.state.external_ip
      }
    }
    
    var systemState = this.systemState()
    if (systemState && systemState.network) {
      this.device_ip = systemState.network.ip_address 
    }
    
    return this.device_ip
  }
  
  IPScheme(refresh = false) {
    if (this.ip_scheme && !refresh) {
      return this.ip_scheme
    }
    
    if (this.state && this.state.ip_scheme) {
      this.ip_scheme = this.state.ip_scheme
      return this.ip_scheme
    }
    
    var systemState = this.systemState()
    if (systemState && systemState.config) {
      this.ip_scheme = systemState.config.ip_scheme
      return this.ip_scheme
    }
    
    return false
  }
  
  hasXMLConfig() {
    var systemState = this.systemState()
    if (systemState && systemState.config && systemState.config.xml) {
      return systemState.config.xml.enabled
    }
    return false
  }
  
  firmwareVersion() {
    if (this.state && this.state.daemon_version) {
      if (this.state.daemon_version != 'Unknown') {
        
        this.firmware_version = 'v' + this.state.daemon_version
        
        if (this.state.system_version != 'Unknown' && this.state.firmware_version != 'Unknown') {
          this.firmware_version += '.' + this.state.system_version + '.' + this.state.firmware_version
        }
        
        this.daemon_version = Vue.helpers.parseVersion('device', this.firmware_version)
        this.system_version = this.state.system_version
        
        return this.firmware_version
      } else if (this.product_name == 'edgecaster_max' && this.state.daemon_version == 'Unknown') {
        // hardcode all unknown versions to 10.0 as thats what Max released with
        this.firmware_version = 'v10.0.0'
        this.daemon_version = Vue.helpers.parseVersion('device', this.firmware_version)
        this.system_version = this.state.system_version
        
        return this.firmware_version
      }
    } 
    
    return 'Unknown'
  }
  
  hasUpdates() {
    for (var key in this.updatesAvailable) {
      if (this.updatesAvailable[key]) {
        return true
      }
    }
    return false
  }
  
  isUpdating() {
    if (this.commandGUID && (this.command == 'update_cloud' || this.command == 'update_device') ) {
      return true
    } else if (this.product_name == 'edgecaster_max' && this.state && this.state.update_state) {
      var systemState = this.state.update_state.find(x => (x.module == 'system'))
      if (systemState && systemState.state && systemState.status.toLowerCase() == 'downloading update') {
        return true
      } else if (systemState && systemState.state && (systemState.action.toLowerCase() == 'apply' && systemState.state.toLowerCase() == 'in_progress')) {
        return true
      }
    }
    
    return false
  }
  
  fetchMetrics() {
    // dont fetch if we already have data and we havent passed the cache interval as defined by services.cloud.metrics.send_rate
    if (
      this.deviceMetrics 
      && this.deviceMetrics.hasChartData()
      && this.lastDeviceMetricsRequestAt
      && new Date().getTime() < (this.lastDeviceMetricsRequestAt + (this.deviceMetricsCacheInterval * 1000))
    ) {
      // silent return
      return
    }
    
    if (!this.isReady()) {
      console.log('VideonDevice ' + this.device_guid + ' fetchMetrics device isnt ready...')
      setTimeout(() => {
        this.fetchMetrics()
      }, 500)
      return
    }
    
    if (this.fetchingMetrics) {
      console.log('VideonDevice ' + this.device_guid + ' fetchMetrics already fetching...')
      return
    }
    
    if (!this.metricsStore) {
      if (store.getters['userPreferences/oldMetrics']) {
        this.deviceMetrics = new CloudWatchDeviceMetrics()
      } else {
        this.deviceMetrics = new NewDeviceMetrics()
      }
    }
    
    this.deviceMetrics.devices = [this]
    
    this.deviceMetrics.metrics = [
      'device|cpu_percent_used', 
      'device|memory_system_percent_used', 
      'device|network_eth0_bytes_sent_per_second'
    ]
    
    if (this.product_name == 'edgecaster') {
      this.deviceMetrics.metrics.push('device|filesystem_/data_percent_used')
      this.deviceMetrics.metrics.push('device|thermal_som_temp_current')
    } else if (this.product_name == 'edgecaster_max') {
      this.deviceMetrics.metrics.push('device|filesystem_/persist_percent_used')
      this.deviceMetrics.metrics.push('device|thermal_video-usr_temp_current')
    }
    
    var endTime = moment()
    
    // weird adjustment to land on a period interval and include the last period
    if (endTime.minute() >= 30) {
      endTime.set({minute: 0, second: 0})
      this.deviceMetrics.end_time = endTime.add('1', 'hour').toISOString()
    } else {
      endTime.set({minute: 30, second: 0})
      this.deviceMetrics.end_time = endTime.toISOString()
    }
    
    this.deviceMetrics.start_time = endTime.subtract('12', 'hour').toISOString()
    
    console.log('VideonDevice ' + this.device_guid + ' fetchMetrics')
    this.fetchingMetrics = true
    this.lastDeviceMetricsRequestAt = new Date().getTime()
    
    this.deviceMetrics.fetchMetrics().then(() => {
      this.fetchingMetrics = false
    }).catch((error) => {
      this.fetchingMetrics = false
      console.log('VideonDevice ' + this.device_guid + ' fetchMetrics error', Vue.helpers.parseError(error))
    })
  }
  
  checkForUpdates() {
    if (!this.product_name) {
      console.log('VideonDevice ' + this.device_guid + ' checkForUpdates product_name is unknown, skipping')
      return
    }
    
    this.updatesAvailable = { 'daemon': false, 'system': false, 'cloud': false }
    
    // update logic is separated by platform
    if (this.product_name == 'edgecaster') {
      // cloud agent check
      var latestCloudVersion = Vue.latestVersions.getLatestVersion('cloud')
      if (this.cloud_version && latestCloudVersion.ready) {
        var parsedLatestCloudVersion = Vue.helpers.parseVersion('cloud', latestCloudVersion.version)
        
        // Don't allow cloud updates from the following versions
        var forbiddenVersions = [
          'V1.0.0b44',
          'V1.0.0b44-BB-PROD'
        ]
      
        if (!forbiddenVersions.includes(this.cloud_version.original) && Vue.helpers.isNewerVersion(this.cloud_version, parsedLatestCloudVersion)) {
          this.updatesAvailable['cloud'] = parsedLatestCloudVersion
        }
      }
      
      // edgecaster daemon version check
      if (this.state && this.state.update_state) {
        var latestDaemonVersion = this.state.update_state.find(x => (x.module == 'daemon' || x.module == 'Daemon'))
        if (latestDaemonVersion) {
          var parsedLatestDaemonVersion = Vue.helpers.parseVersion('device', latestDaemonVersion.target_version)
          
          if (!this.daemon_version || Vue.helpers.isNewerVersion(this.daemon_version, parsedLatestDaemonVersion)) {
            this.updatesAvailable['device'] = parsedLatestDaemonVersion
          }
        }
      }
    } else if (this.product_name == 'edgecaster_max') {
      // max system version check
      if (this.state && this.state.update_state) {
        var latestSystemVersion = this.state.update_state.find(x => (x.module == 'system'))
        if (latestSystemVersion) {
          var parsedLatestSystemVersion = Vue.helpers.parseVersion('device', '' + latestSystemVersion.target_version)
          
          if (!this.firmware_version || latestSystemVersion.target_version > this.system_version) {
            this.updatesAvailable['device'] = parsedLatestSystemVersion
          }
        }
      }
      
    }
  }
  
  async requestInputPreview(force = false) {
    if (!this.device_guid) {
      return true
    }
    
    // if the window doesnt have focus, dont request...
    if (!force && !document.hasFocus()) {
      return true
    }
    
    // we need to filter requestInputPreview through the device as to not send too many concurrent commands
    if (this.lastInputPreviewRequestAt && new Date().getTime() < (this.lastInputPreviewRequestAt + (this.inputPreviewDuration * 1000))) {
      return true
    }
    
    this.lastInputPreviewRequestAt = new Date().getTime()
    
    var commandObject = {'command': 'send_input_preview', 'data': {'duration': this.inputPreviewDuration, 'sample_interval': this.inputPreviewInterval}}
    
    try {
      let response = await Vue.axios.post('/devices/' + this.device_guid + '/commands', commandObject)
      console.log('VideonDevice ' + this.device_guid + ' requestInputPreview response', response)
      return true
    } catch (error) {
      console.log('VideonDevice ' + this.device_guid + ' requestInputPreview error', Vue.helpers.parseError(error))
    }
    
    return false
  }
  
  inputsState() {
    var inputsShadow = Vue.deviceShadows.getDeviceShadow(this.device_guid, 'Inputs')
    if (inputsShadow.reported) {
      return inputsShadow.reported.state
    } 
    return []
  }
  
  outputsState() {
    var outputsShadow = Vue.deviceShadows.getDeviceShadow(this.device_guid, 'Outputs') 
    if (outputsShadow.reported) {
      return outputsShadow.reported.state.filter(output => (Vue.helpers.outputStatus(output).configured === true && output.type != 'thumbnail'))
    } 
    return []
  }
  
  encodersState() {
    var encodersShadow = Vue.deviceShadows.getDeviceShadow(this.device_guid, 'Encoders') 
    if (encodersShadow.reported) {
      return encodersShadow.reported.state
    } 
    return []
  }
  
  encoderByID(id) {
    var encoders = this.encodersState()
    return encoders.find(x => (x.id == id))
  }
  
  systemState() {
    var systemShadow = Vue.deviceShadows.getDeviceShadow(this.device_guid, 'System') 
    if (systemShadow.reported) {
      return systemShadow.reported.state
    } 
    return false
  }
  
  outputsChain() {
    var outputs = []
    var inputs = []
    var encoders = []
    
    // we need to work on editableState, not the actual objects as to avoid messing with cache...
    var inputsShadow = Vue.deviceShadows.getDeviceShadow(this.device_guid, 'Inputs')
    if (inputsShadow.reported) {
      inputs = inputsShadow.editableStateCopy()
    }
    
    var encodersShadow = Vue.deviceShadows.getDeviceShadow(this.device_guid, 'Encoders')
    if (encodersShadow.reported) {
      encoders = encodersShadow.editableStateCopy()
    }
    
    var outputsShadow = Vue.deviceShadows.getDeviceShadow(this.device_guid, 'Outputs') 
    if (outputsShadow.reported) {
      var outputState = outputsShadow.editableStateCopy().filter(output => (Vue.helpers.outputStatus(output).configured === true && output.type != 'thumbnail'))
      
      outputs = outputState.map((output) => {
        output.encoders = []
        
        if (output.config.sources.video) {
          output.encoders = output.encoders.concat(encoders.filter(encoder => output.config.sources.video.indexOf(encoder.id) !== -1))
        }
        
        if (output.config.sources.audio) {
          output.encoders = output.encoders.concat(encoders.filter(encoder => output.config.sources.audio.indexOf(encoder.id) !== -1))
        }
        
        if (output.config.sources.data) {
          output.encoders = output.encoders.concat(encoders.filter(encoder => output.config.sources.data.indexOf(encoder.id) !== -1))
        }
        
        output.inputs = inputs.filter(input => output.encoders.findIndex(encoder => encoder.config.in_channel_id == input.id) !== -1)
        
        return output
      })
    }
    
    return outputs
  }
  
  
  outputColumnView() {
    var outputsChain = this.outputsChain()
    
    var rows = {}
    
    for (var output of outputsChain) {
      if (output.inputs && output.inputs.length > 0 && output.inputs[0].id) {
        if (output.inputs.length > 0 && !rows[output.inputs[0].id]) {
          rows[output.inputs[0].id] = {'inputs': [], 'encoders': [], 'outputs': []}
        }
      
        for (var input of output.inputs) {
          if (!rows[output.inputs[0].id].inputs.find(x => x.id == input.id)) {
            rows[output.inputs[0].id].inputs.push(input)
          }
        }
        
        for (var encoder of output.encoders) {
          if (!rows[output.inputs[0].id].encoders[encoder.type]) {
            rows[output.inputs[0].id].encoders[encoder.type] = []
          }
          
          if (!rows[output.inputs[0].id].encoders[encoder.type].find(x => x.id == encoder.id)) {
            rows[output.inputs[0].id].encoders[encoder.type].push(encoder)
          }
        }
        
        rows[output.inputs[0].id].outputs.push(output)
      }
      
    }
    
    return Object.keys(rows).map((id) => rows[id])
  }
  
  fallbackColumnView() {
    var inputs = []
    var encoders = []
    var outputs = []
    
    var inputsShadow = Vue.deviceShadows.getDeviceShadow(this.device_guid, 'Inputs')
    if (inputsShadow.reported) {
      inputs = inputsShadow.editableStateCopy()
    }
    
    var encodersShadow = Vue.deviceShadows.getDeviceShadow(this.device_guid, 'Encoders')
    if (encodersShadow.reported) {
      encoders = encodersShadow.editableStateCopy()
    }
    
    var outputsShadow = Vue.deviceShadows.getDeviceShadow(this.device_guid, 'Outputs') 
    if (outputsShadow.reported) {
      outputs = outputsShadow.editableStateCopy().filter(output => (Vue.helpers.outputStatus(output).configured === true && output.type != 'thumbnail'))
    }
    
    var row = {
      'inputs': [],
      'encoders': {},
      'outputs': [],
      'fallback': true
    }
    
    row.inputs = inputs
    
    if (encoders) {
      for (var encoder of encoders) {
        if (!row.encoders[encoder.type]) {
           row.encoders[encoder.type] = []
        }
        if (!row.encoders[encoder.type].find(x => x.id == encoder.id)) {
          row.encoders[encoder.type].push(encoder)
        }
      }
    }
    
    row.outputs = outputs
    
    return [row]
  }
  
  
  updateStreamingStatus() {
    if (!this.state) {
      this.streaming_status = 5
    } else if (!this.state.online) {
      this.streaming_status =  4
    } else if (this.outputsState().filter(output => Vue.helpers.outputStatus(output).streaming === false && Vue.helpers.outputStatus(output).enabled === true).length > 0) {
      this.streaming_status =  0
    } else if (this.outputsState().filter(output => Vue.helpers.outputStatus(output).streaming === true).length > 0) {
      this.streaming_status =  1
    } else if (this.outputsState().filter(output => Vue.helpers.outputStatus(output).streaming === false).length > 0) {
      this.streaming_status =  2
    } else if (this.outputsState().filter(output => Vue.helpers.outputStatus(output).streaming === false).length == 0) {
      this.streaming_status =  3
    }
    return this.streaming_status
  }
  
  
  thumbnailEnabled(index = 0) {
    if (index < 0) {
      return false
    }
    
    var outputsShadow = Vue.deviceShadows.getDeviceShadow(this.device_guid, 'Outputs') 
    
    if (outputsShadow.reported) {
      // sort thumbnail outputs by id
      var thumbnailOutputs = outputsShadow.reported.state.filter(output => (output.type == 'thumbnail')).sort(function(a, b) {return a.id - b.id})
      
      if (thumbnailOutputs.length > 0 && thumbnailOutputs[index]) {
        if (Vue.helpers.outputStatus(thumbnailOutputs[index]).configured === true && Vue.helpers.outputStatus(thumbnailOutputs[index]).enabled === true) {
          return true
        }
      }
    }
    
    return false
  }
}